import qs from 'qs';
import StorageHelper from '../helpers/StorageHelper';

export function interceptorAddToken(
  config,
  {
    // Adicionar headers de autenticação. Por padrão usar o token da API USUARIOS
    headerName = 'Authorization',
    tokenPrefix = 'Bearer',
    token = StorageHelper.getTokenUsuario(),
  } = {},
) {
  if (token && !config.headers[headerName]) {
    config.headers[headerName] = `${tokenPrefix} ${token}`.trim();
  }

  return config;
}

export function queryString(params = {}, options = {}) {
  return qs.stringify(parseParams(params), { arrayFormat: 'brackets', ...options });
}

export function parseParams(data = {}) {
  for (const attr in data) {
    let value = data[attr];

    // Ignore undefined
    if (typeof value === 'undefined') {
      continue;
    }

    // Transform bool to intbool
    if (typeof value === 'boolean') {
      value = Number(value);
    }

    // Transform null to empty string
    if (value === null) {
      value = '';
    }

    data[attr] = value;
  }

  return data;
}

export function formData(data = {}) {
  data = parseParams(data);

  const form = new FormData();

  for (const attr in data) {
    form.append(attr, data[attr]);
  }

  return form;
}
